import { Flex, Spacing, Text } from '@billy/design-system'
import { format } from 'date-fns'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useBankIntegration } from '@features/openBanking/contexts/bankIntegrationContext'
import { useOpenBankingAccounts } from '@features/openBanking/hooks/useOpenBankingAccounts'
import { BankReconciliationAccountSelect } from '@features/reconciliation/elements/BankReconciliationAccountSelect'

interface AccountDetailsProps {
  currentAccountName: string
}

export const AccountDetails = ({ currentAccountName }: AccountDetailsProps): ReactElement => {
  const { t } = useTranslation()
  const { openBankingAccounts } = useOpenBankingAccounts()
  const { accountId } = useBankIntegration()

  const connectedBank = useMemo(
    () => openBankingAccounts?.find((openBankingAccount) => openBankingAccount.externalAccountId === accountId),
    [openBankingAccounts, accountId],
  )

  const lastPullTimeFormatted = useMemo(
    () =>
      connectedBank?.lastSynchronizedAt && format(new Date(connectedBank.lastSynchronizedAt), 'MMM. dd yyyy, HH:mm'),
    [connectedBank],
  )

  return (
    <Flex gap={Spacing.S12} alignItems="center">
      <BankReconciliationAccountSelect selectedId={accountId} withConnectNewAccountAction={true} />
      {lastPullTimeFormatted && (
        <Flex flexDirection="column">
          <Text variant="bodySM" colorVariant="placeholder" nowrap>
            {t('bank_integrations.top_actions.last_pull')}
          </Text>
          <Text variant="bodySM" colorVariant="placeholder">
            {lastPullTimeFormatted}
          </Text>
        </Flex>
      )}
    </Flex>
  )
}
